import { render, staticRenderFns } from "./shimmer.vue?vue&type=template&id=32c48e4a&scoped=true&"
import script from "./shimmer.vue?vue&type=script&lang=js&"
export * from "./shimmer.vue?vue&type=script&lang=js&"
import style0 from "./shimmer.vue?vue&type=style&index=0&id=32c48e4a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c48e4a",
  null
  
)

export default component.exports